/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44d0856f2b7524f776fd18f411fdf7ee>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "VehicleCar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Transport emoji category.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const VehicleCarIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.277 3.182A2.56 2.56 0 0 1 4.81 1h6.378c1.268 0 2.346.928 2.534 2.182l.274 1.826 1.28-.672.697 1.328-1.537.808A3.25 3.25 0 0 1 16 9.25v4.375c0 .76-.616 1.375-1.375 1.375h-2.25c-.76 0-1.375-.616-1.375-1.375V13.5H5v.125C5 14.385 4.384 15 3.625 15h-2.25C.615 15 0 14.384 0 13.625V9.25c0-1.177.626-2.208 1.563-2.778L.026 5.664l.698-1.328 1.279.672zM3.37 6l.39-2.595c.077-.52.524-.905 1.05-.905h6.378c.526 0 .973.385 1.05.905L12.63 6zm-.12 1.5A1.75 1.75 0 0 0 1.5 9.25v4.25h2v-.125c0-.76.616-1.375 1.375-1.375h6.25c.76 0 1.375.616 1.375 1.375v.125h2V9.25a1.75 1.75 0 0 0-1.75-1.75zm2.75 3H3V9h3zm7 0h-3V9h3z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
VehicleCarIcon.displayName = 'VehicleCarIcon';
var _default = exports.default = VehicleCarIcon;